import type { TransmissionType } from "@/constants/transmission-type";
import {VehicleType} from "@/constants/vehicle-type";
import { Country } from '@/constants/country';
import { VehicleStatus } from '@/constants/vehicle-status';
import { AssignmentDrivability } from "@/constants/assignment-drivability";

export interface BaseVehicle {
    country: Country;
    brand?: string;
    model?: string;
    weight?: number;
    color?: string;
    licensePlate: string;
    chassisNumber?: string;
    type: string;
    transmissionType?: TransmissionType,
    width?: number;
    height?: number;
    length?: number;
}

export interface Vehicle extends BaseVehicle {
    id?: number;
    status?: VehicleStatus;
    internalRemarks?: string;
    externalRemarks?: string;
    drivability?: AssignmentDrivability;
    transportedByRoad?: boolean;
    //Used when creating only
    reference?: string;
}

export const DefaultVehicle = () => {
    return {
        country: Country.NL,
        licensePlate: '',
        type: VehicleType.PassengerVehicle,
        status: VehicleStatus.Available,
        drivability: AssignmentDrivability.Drivable,
        transportedByRoad: false,
    } as Vehicle
}

export const ApplyVehicleData = (createVehicle: Vehicle, vehicleData: Vehicle) => {
    createVehicle.brand = vehicleData.brand;
    createVehicle.brand = vehicleData.brand;
    createVehicle.model = vehicleData.model;
    createVehicle.weight = vehicleData.weight;
    createVehicle.color = vehicleData.color;
    createVehicle.licensePlate = vehicleData.licensePlate;
    createVehicle.type = vehicleData.type;
    createVehicle.transmissionType = vehicleData.transmissionType;
    createVehicle.width = vehicleData.width;
    createVehicle.height = vehicleData.height;
    createVehicle.length = vehicleData.length;
    return createVehicle;
}
